import { Component, OnInit, Input } from '@angular/core';
import { ProjectDto, UserRoleDto} from "../../data/CommandServiceDtos.generated";


@Component({
  selector: 'project-list',
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.scss']
})
export class ProjectListComponent implements OnInit {
 
  @Input() projects: ProjectDto[];
  @Input() clientCount: number;
  @Input() userRoles: UserRoleDto[];


  constructor() { }

  ngOnInit() {
  }

  onlyTwoItems() {
    if (this.projects.length === 2) 
      return true;

    return false;

  }
}



// WEBPACK FOOTER //
// ./src/app/components/project-list/project-list.component.ts